export default __webpack_public_path__ + "static/media/4.4fbd50e8.png";